import { Globe } from 'lucide-react';

import { Button } from '@/components/atoms/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/molecules/dropdown-menu';
import { useConfigStore } from '@/lib/stores/config.store';
import { locales, localeNames, type Locale } from '@/i18n/config';
import { useIsMounted } from '@/lib/hooks/use-is-mounted';

export function LanguageSwitcher() {
  const { locale, setLocale } = useConfigStore();
  const isMounted = useIsMounted();

  const handleLocaleChange = (newLocale: Locale) => {
    setLocale(newLocale);
  };

  // Render placeholder during SSR to avoid hydration mismatch with Radix UI
  if (!isMounted) {
    return (
      <Button variant="ghost" size="icon">
        <Globe className="size-5" />
        <span className="sr-only">Change language</span>
      </Button>
    );
  }

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="icon">
          <Globe className="size-5" />
          <span className="sr-only">Change language</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        {locales.map((loc) => (
          <DropdownMenuItem
            key={loc}
            onClick={() => handleLocaleChange(loc)}
            className={locale === loc ? 'bg-accent' : ''}
          >
            {localeNames[loc]}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
